import React from "../../../__compat__/react/main.entry.mjs.mjs";
import { GenericOption } from "../GenericOption/GenericOption.mjs.mjs";
export const RadioButton = React.forwardRef(function RadioButton(props, ref) {
    return React.createElement(GenericOption, { ...props, type: "radio", ref: ref });
});
//# sourceMappingURL=RadioButton.mjs.mjs.map